import React from "react";
import { useStateManager, BCMSDate, BrandingStyle } from "bcms-react";
import { Account } from "model";

import { SVGAsset } from "res";
import { FormContainer, FormRowView } from "components/shared";
import { FormButtonRow, HorizontalFormRow } from "components/shared/containers/FormContainer";
import CustomAccordion, { CustomAccordionContent, CustomAccordionToggle, useCustomAccordion } from "components/custom-ui/CustomAccordion";
import IconToggle from "components/shared/views/IconToggle";
import { PrimaryButton, SecondaryButton, UIAmountInput } from "components/ui";
import CustomSelect, { CustomAccountSelect, CustomSelectItem } from "components/custom-ui/CustomSelect";
import UIRadioGroup, { UIRadio } from "components/custom-ui/UIRadioGroup";
import DateSelect from "components/custom-ui/DateSelect";

import "../../styles.css";
import "./styles.css";
import "./mobile.css";

export default function DepositHistorySearchAccordion(props){
    const { ui, onAccordionToggle } = useStateManager();

    return (
        <CustomAccordion className="search-accordion" isOpen={ ui.showSearchAccordion }>
            <CustomAccordionToggle className="flex-container flex-horizontal align-center search-button-container accordion-toggle" onClick={ onAccordionToggle }>
                <IconToggle icon="MagnifyingGlassIcon" text="Search" dataPoint="Toggle_Deposit_Search_Search" />
            </CustomAccordionToggle>
            
            <DepositHistorySearchContent />
        </CustomAccordion>
    );
}

function DepositHistorySearchContent(props) {
    const { data, ui, onSearchSubmit, onSearchReset, onShowAmountRange, onSearchUpdate, onAccordionToggle } = useStateManager();

    const generateOptions = obj => [...obj].map(([key, value]) => {
        const item = <CustomSelectItem key={`Item_${key}`} data-point={value.replace(/ /g, "_")} value={key}>{value}</CustomSelectItem>;
        //return key !== "custom" ? item : <DisabledPrompt key={ `Disabled_${ key }` }>{ item }</DisabledPrompt>;
        return item;
    }, []);

    const search = data.search;
    const dateOptions = generateOptions(search.ranges);
    const amountRange = ui.showAmountRange;
    const showCustomDateRange = ui.showCustomDateRange;
    const amountRangeSelection = amountRange ? "Amount Range" : "Amount";

    const disableDay = date => {
        const startDate = BCMSDate.init(search.startDate);
        return date.isBefore(startDate);
    };

    return (
        <>
          <CustomAccordionContent className="search-toggle-content-container flex-container flex-vertical deposit-history-search-content">
            <CustomAccordionToggle className="flex-container close-accordion" onClick={ onAccordionToggle }>
              <BrandingStyle style={{"color": "search_text_abi22"}} className="flex-width" element={
              <p>SEARCH</p>
              } />

              <SVGAsset className="set-width" id="CloseX" data-point="Close_Search_Icon" />
            </CustomAccordionToggle>
            <FormContainer className="small-form-width">
              <FormRowView text="Account">
                <CustomAccountSelect className="statements-account-select" value={search.account} accounts={Account.initAll()} onChange={onSearchUpdate("account")} dataPoint="Account_DD">
                  <CustomSelectItem value="all">All Accounts</CustomSelectItem>
                </CustomAccountSelect>
              </FormRowView>
              {/*<FormRowView text="Account">
                <CustomSelect>
                  <CustomSelectItem>All Accounts</CustomSelectItem>
                </CustomSelect>
              </FormRowView>*/}
              <FormRowView text="Date Range">
                <CustomSelect value={search.date} onChange={onSearchUpdate("date")} dataPoint="Date_Range_Deposit">
                  {dateOptions}
                </CustomSelect>
              </FormRowView>
              {/*<FormRowView text="Date Range">
                <CustomSelect>
                  <CustomSelectItem>Last 30 Days</CustomSelectItem>
                  <CustomSelectItem>Last 60 Days</CustomSelectItem>
                  <CustomSelectItem>Last 90 Days</CustomSelectItem>
                  <CustomSelectItem>Last 120 Days</CustomSelectItem>
                  <CustomSelectItem>Custom Range</CustomSelectItem>
                </CustomSelect>
              </FormRowView>*/}
              {showCustomDateRange &&
                <HorizontalFormRow>
                  <div className="flex-container flex-width date-select-row">
                    <FormRowView className="dual-input" text="Start Date">
                      <DateSelect value={search.startDate} onChange={ onSearchUpdate("startDate")} enablePast={true} enableFuture={false} dataPoint="Date_Start_Deposit" />
                    </FormRowView>
                    <FormRowView className="dual-input" text="End Date" >
                      <DateSelect value={search.endDate} onChange={ onSearchUpdate("endDate")} enablePast={true} enableFuture={false} disableDay={disableDay} dataPoint="Date_End_Deposit" />
                    </FormRowView>
                  </div>
                </HorizontalFormRow>
              }
              <UIRadioGroup value={amountRangeSelection} onChange={ onShowAmountRange }>
                <div className="flex-container">
                  <UIRadio label="Amount" dataPoint="Amount_Type_Deposit" />
                  <UIRadio label="Amount Range" dataPoint="Amount_Range_Type_Deposit" />
                </div>
              </UIRadioGroup>
              {/*
              <UIRadioGroup label="Stop Payment Type:" value={stopPayment.paymentType} onChange={onChange("paymentType")} >
                    <UIRadio name="stop-payment-type" label="Single Check" dataPoint="Single_Check" />
                    <UIRadio name="stop-payment-type" label="Range of Checks" dataPoint="Range_Check"  />
                  </UIRadioGroup>
              */}
              {amountRange &&
                <HorizontalFormRow>
                  <div className="flex-container flex-width date-select-row">
                    <FormRowView className="dual-input" text="Minimum Amount">
                      <UIAmountInput value={ search.minAmount ? search.minAmount.amount : "" } onChange={ onSearchUpdate("minAmount")} dataPoint="Amount_Minimum_Deposit" />
                    </FormRowView>
                    <FormRowView className="dual-input" text="Maximum Amount">
                      <UIAmountInput value={ search.maxAmount ? search.maxAmount.amount : "" } onChange={ onSearchUpdate("maxAmount")} dataPoint="Amount_Maximum_Deposit" />
                    </FormRowView>
                  </div>
                </HorizontalFormRow>
              }
              {!amountRange &&
                <FormRowView text="Amount">
                  <UIAmountInput value={ search.amount ? search.amount.amount : "" } onChange={ onSearchUpdate("amount")} dataPoint="Amount_Input_Deposit" />
                </FormRowView>
              }
              <FormButtonRow className="search-accordion-buttons">
                <div className="flex-width show-on-desktop">
                  <SecondaryButton text="Clear" onClick={ onSearchReset } dataPoint="Clear_Deposit_Search" />
                  <PrimaryButton text="Search" onClick={ onSearchSubmit } dataPoint="Submit_Deposit_Search" />
                </div>
                <div className="flex-width show-on-mobile">
                  <PrimaryButton text="Search" onClick={ onSearchSubmit } dataPoint="Submit_Deposit_Search" />
                  <SecondaryButton text="Clear" onClick={ onSearchReset } dataPoint="Clear_Deposit_Search" />
                </div>
              </FormButtonRow>
            </FormContainer>
          </CustomAccordionContent>
    
          {/* The search criteria component needs to be hidden until the user searched for a deposit */}
          {/* <div className="hide">
                <DepositHistorySearchCriteria />
              </div>*/}
          {/* The No Search Results component needs to be hidden until the user searched for a deposit and the search does not match any deposits */}
          {/*<div className="hide">
                <DepositHistoryNoResults />
              </div>*/}
          {/* <DepositHistoryView deposits={deposits} /> */}
          {/*<DepositHistoryView date={date} accountName={accountName} accountNumber={accountNumber} status={status} amount={amount} transactionID={transactionID} source={source} />*/}
          {/*<div className="end-of-transactions-message flex-container">
                <SVGAsset id="InfoIcon" className="info-icon set-width" />
                <p className="flex-width">End of recent transactions. Please use the Search feature to see older transactions.</p>
              </div>*/}
        </>
      )
}